import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import {
  getColumnKey,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { AdminShippingMethodCollectionItem } from '../../models/admin-shipping-method-collection-item';
import { AdminShippingMethodCollectionFilter } from '../../models/admin-shipping-method-collection-filter';
import { isNotNil } from '@web/utils';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';

@Component({
  selector: 'app-admin-shipping-method-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    SummernoteHtmlPreviewComponent,
    NoDataComponent,
  ],
  templateUrl:
    './admin-shipping-method-list-custom-cell-template.component.html',
  styleUrl: './admin-shipping-method-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminShippingMethodListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminShippingMethodCollectionItem, AdminShippingMethodCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminShippingMethodCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminShippingMethodCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
